
import React from 'react'
import { FiTrash2, FiEdit2 } from "react-icons/fi"

export const FeaturingItem = ({item}) =>{
    return (
        <li >
        <div>
            <div>
                 <h4 className="title">{item?.position} </h4>
                 <h3 className="company">{item?.company}</h3>
                 <div className="date">
                     { item?.start }
                     {` - `}  { item?.working ? `Continues` : item?.end  }
                     { item?.city  && ` - ` + item.city}
                 </div>
                 <p className="description">{item?.description}</p>
             </div>
             <div className="trash">
                 <FiTrash2 />
             </div>
             <div className="edit" ><FiEdit2 /> Edit </div>
        </div>
     </li>
    )
}